// https://vuex.vuejs.org/en/state.html

export default {
  status: '',
  user: JSON.parse(localStorage.getItem('user')),
  snackbar: { color: 'accent', message: '', show: false }
}
